import React from "react";
import "./whychoose.scss";

const whychoose = () => {
  return (
    <div className="whychoose">
      <div className="container-whychoose">
        <div className="header-whychoose">Why Choose Us</div>
        <div className="container-value">
          <div className="value">
            <div className="hv">Lokasi Strategis</div>
            <div className="dv">
              Lokasi Grand Wisata Bekasi dekat dengan tol (JORR 2 dan Jakarta
              Cikampek) yang mempermudah akses ke kota-kota besar lainnya di
              Jabodetabek.
            </div>
          </div>
          <div className="value">
            <div className="hv">Infrastruktur Internasional</div>
            <div className="dv">
              Perumahan Grand Wisata Bekasi menawarkan akses ke berbagai kota
              dengan infrastruktur kelas dunia yang terhubung.
            </div>
          </div>
          <div className="value">
            <div className="hv">Kesehatan & Pendidikan</div>
            <div className="dv">
              Dekat dengan rumah sakit besar dengan pelayanan yang bagus,
              seperti RS Permata Cibubur dan RS Meilia. Serta Anda dapat
              menikmati pendidikan di sekolah-sekolah terbaik, termasuk yang
              bertaraf internasional.
            </div>
          </div>
          <div className="value">
            <div className="hv">Nilai Potensial</div>
            <div className="dv">
              Pengembang yang berpengalaman memastikan standar kualitas tinggi
              dalam pembangunan perumahan yang menjamin nilai properti akan
              meningkat di masa depan.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default whychoose;
